<template>
  <SvgBase width="24" height="24" viewBox="0 0 24 24" fill="none">
    <title>RFID Power High</title>
    <path
      d="M8 16C8 14.3431 9.34315 13 11 13H13C14.6569 13 16 14.3431 16 16"
      :stroke="color"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M5 12C5 9.23858 7.23858 7 10 7H14C16.7614 7 19 9.23858 19 12"
      :stroke="color"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M2 8C2 4.68629 4.68629 2 8 2H16C19.3137 2 22 4.68629 22 8"
      :stroke="color"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <circle cx="12" cy="19" r="1.5" :fill="color" />
  </SvgBase>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import SvgBase from './SvgBase.vue'

@Options({
  components: {
    SvgBase,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
  },
})
export default class IconRfidPowerHigh extends Vue {}
</script>
